<template>
  <div
    class="section section-panel cell-block-y"
    :class="{ 'is-mobile-open': mobileOpen }">
    <div class="flex flex-col flex-grow">
      <div class="section-panel-head">
        <router-link :to="{ name: 'home'}" class="flex flex-col items-start" @click.native="closeMobileIfOpen">
          <img class="w-16 cursor-pointer" src="@/assets/images/iwaly.svg" alt="iwaly">
          <span>Администратор</span>
        </router-link>
        <button
          type="button"
          class="mobile-navigation-close"
          aria-label="Закрыть меню"
          @click="$emit('close-mobile')">
        </button>
      </div>
      <div class="section-panel-data">
        <nav>
          <ul>
            <router-link
              tag="li"
              :to="tab.push"
              :key="index"
              :class="[
                {
                  active: tab.mobileOnly
                    ? isMobileOnlyTabActive(tab)
                    : tab.push.name && tab.push.name === ($route.name || '').split('.')[0]
                },
                { 'nav-mobile-only': tab.mobileOnly },
                { 'mobile-parent-active-suppressed': suppressParentActiveOnMobile(tab) },
              ]"
              v-for="(tab, index) in tabs"
              @click.native="closeMobileIfOpen">
              <span>{{ tab.title }}</span>
            </router-link>
          </ul>
        </nav>
        <div>
          <div class="w-8 h-8 rounded-full">
            <img
              class="w-full h-full object-cover object-center"
              src="@/assets/images/iwaly-icon.png">
          </div>
          <b v-if="$delve(user, 'name')">
            {{ $delve(user, 'name') | fullname }}
          </b>
          <span @click="logout()">Выход</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ADMIN_PERMISSIONS, canAccess, canAccessAny } from '@/access/adminAccess';

export default {
  props: {
    mobileOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    tabs() {
      const settingsVisible = canAccessAny(this.user, [
        ADMIN_PERMISSIONS.SETTINGS,
        ADMIN_PERMISSIONS.ADMINS,
        ADMIN_PERMISSIONS.ANALYTICS,
        ADMIN_PERMISSIONS.MONITORING,
        ADMIN_PERMISSIONS.DATABASE,
      ]);

      let settingsRoute = 'settings.limit';
      if (!canAccess(this.user, ADMIN_PERMISSIONS.SETTINGS)) {
        if (canAccess(this.user, ADMIN_PERMISSIONS.ADMINS)) settingsRoute = 'settings.admins';
        else if (canAccess(this.user, ADMIN_PERMISSIONS.ANALYTICS)) settingsRoute = 'settings.analytics';
        else if (canAccess(this.user, ADMIN_PERMISSIONS.MONITORING)) settingsRoute = 'settings.monitoring';
        else if (canAccess(this.user, ADMIN_PERMISSIONS.DATABASE)) settingsRoute = 'settings.db';
      }

      const tabs = [
        { title: 'Заказы', push: { name: 'orders' }, permission: ADMIN_PERMISSIONS.ORDERS },
        { title: 'Исполнители', push: { name: 'contractors' }, permission: ADMIN_PERMISSIONS.CONTRACTORS },
        { title: 'Коммуникации', push: { name: 'communications' }, permission: ADMIN_PERMISSIONS.COMMUNICATIONS },
        { title: 'Услуги', push: { name: 'services' }, permission: ADMIN_PERMISSIONS.SERVICES },
        { title: 'Заказчики', push: { name: 'customers' }, permission: ADMIN_PERMISSIONS.CUSTOMERS },
        { title: 'Объекты', push: { name: 'objects' }, permission: ADMIN_PERMISSIONS.SUBJECTS },
        { title: 'Реферралы', push: { name: 'partners' }, permission: ADMIN_PERMISSIONS.PARTNERS },
        { title: 'Настройки', push: { name: settingsRoute }, visible: settingsVisible },
      ];

      if (this.mobileOpen) {
        tabs.splice(2, 0, {
          title: 'Запросы',
          push: { name: 'contractors.requests' },
          permission: ADMIN_PERMISSIONS.CONTRACTORS,
          mobileOnly: true,
        });
      }

      return tabs.filter((tab) => (typeof tab.visible === 'boolean'
        ? tab.visible
        : canAccess(this.user, tab.permission)));
    },
  },
  filters: {
    fullname(s) {
      if (s) {
        return s.replace(/(\S+) (\S)\S* (\S)\S*/, '$1 $2. $3.');
      }
      return s;
    },
  },
  methods: {
    closeMobileIfOpen() {
      if (this.mobileOpen) {
        this.$emit('close-mobile');
      }
    },
    isMobileOnlyTabActive(tab) {
      const routeName = this.$route.name || '';
      return !!tab.mobileOnly && routeName.indexOf(tab.push.name) === 0;
    },
    suppressParentActiveOnMobile(tab) {
      const routeName = this.$route.name || '';
      return tab.push.name === 'contractors'
        && routeName.indexOf('contractors.requests') === 0;
    },
    ...mapActions({
      logout: 'auth/ACT_LOGOUT',
    }),
  },
  watch: {
    '$route.fullPath': function routeChanged() {
      this.closeMobileIfOpen();
    },
  },
};
</script>
